import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImageSlash } from "@fortawesome/pro-regular-svg-icons";
import "./facilityIntegrationCard.scss";
import { Badge } from "components/badge/Badge";
import { IFacilityIntegration } from "pages/secure/facility/settings/facility/FacilityIntegrations";
import moment from "moment";
import { capitalize } from "helpers/Helpers";

interface IFacilityIntegrationCardProps {
  integration: IFacilityIntegration;
  onSetupClick: () => void;
}

const FacilityIntegrationCard: React.FC<IFacilityIntegrationCardProps> = props => {
  const { integration, onSetupClick } = props;

  return (
    <div className="facility-integration-card_container">
      <div className="flex gap-6 h-full">
        <div className="facility-integration-card_logo_container">
          {integration?.logo_url ? (
            <img src={integration?.logo_url} alt={integration?.name} className="facility-integration-card_logo" />
          ) : (
            <div className="facility-integration-card_no_logo">
              <FontAwesomeIcon icon={faImageSlash} className="facility-integration-card_icon" />
            </div>
          )}
        </div>

        <div className="facility-integration-card_info_container">
          <div className="flex flex-col gap-2">
            <p className="facility-integration-card_info_name_text">{integration?.name}</p>

            {integration?.integration ? (
              <>
                <p className="facility-integration-card_info_connected_text">
                  Connected on: {moment(integration?.integration?.created_at).format("MMM D, YYYY")}
                </p>

                <p className="facility-integration-card_info_connected_text">
                  Last used:{" "}
                  {integration?.integration?.last_used
                    ? moment(integration?.integration?.last_used).format("MMM D, YYYY")
                    : "Unused"}
                </p>
              </>
            ) : (
              <p className="facility-integration-card_info_connected_text">Not connected</p>
            )}
          </div>

          {integration?.integration ? (
            <Badge type="success" size="small">
              {capitalize(integration?.integration?.status)}
            </Badge>
          ) : (
            <div></div>
          )}
        </div>
      </div>

      <div className="facility-integration-card_actions_container">
        <button className="facility-integration-card_actions_button" onClick={onSetupClick}>
          {integration?.integration ? "Edit" : "Setup"}
        </button>
      </div>
    </div>
  );
};

export default FacilityIntegrationCard;
